import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import Markdown from 'react-markdown'
import { stringTemplating } from '@cocoonspace/shared/utils/string-templating'
import rehypeRaw from 'rehype-raw'

export const ExtraPrice = ({
	extra,
}: {
	extra: Pick<EventExtra, 'unit_price' | 'fees' | 'sub_title'>
}) => (
	<div
		className='text-sm leading-none'
		data-testid='extra-title-price'
	>
		<div className='text-sm font-normal'>
			<Markdown
				components={{
					small: ({ children }) => <span className='text-xxs'>{children}</span>,
				}}
				rehypePlugins={[rehypeRaw]}
			>
				{stringTemplating(extra.sub_title || '', {
					...extra,
					fees: (extra.fees || 0) / 100,
					price: (extra.unit_price || 0) / 100,
				})}
			</Markdown>
		</div>
	</div>
)
